import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_0c8eb7d0 from 'nuxt_plugin_plugin_0c8eb7d0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_runtimeplugin633efce6_fbf82d8c from 'nuxt_plugin_runtimeplugin633efce6_fbf82d8c' // Source: ./runtime.plugin.633efce6.js (mode: 'server')
import nuxt_plugin_nodecacheplugin_9945246e from 'nuxt_plugin_nodecacheplugin_9945246e' // Source: ./node-cache-plugin.ts (mode: 'all')
import nuxt_plugin_apollomodule_77b2e812 from 'nuxt_plugin_apollomodule_77b2e812' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_runtimeplugin04d6f43d_b4b92bc6 from 'nuxt_plugin_runtimeplugin04d6f43d_b4b92bc6' // Source: ./runtime.plugin.04d6f43d.mjs (mode: 'client')
import nuxt_plugin_distplugin5cd6bd3c_02162cdc from 'nuxt_plugin_distplugin5cd6bd3c_02162cdc' // Source: ./dist.plugin.5cd6bd3c.mjs (mode: 'all')
import nuxt_plugin_persistedState_3bffb41b from 'nuxt_plugin_persistedState_3bffb41b' // Source: ../plugins/persistedState.ts (mode: 'all')
import nuxt_plugin_sharedMutation_432bf589 from 'nuxt_plugin_sharedMutation_432bf589' // Source: ../plugins/sharedMutation.ts (mode: 'client')
import nuxt_plugin_index_dda843de from 'nuxt_plugin_index_dda843de' // Source: ../plugins/globalErrorHandler/index.ts (mode: 'all')
import nuxt_plugin_index_7decf890 from 'nuxt_plugin_index_7decf890' // Source: ../plugins/emitter/index.ts (mode: 'all')
import nuxt_plugin_axios_5659cf26 from 'nuxt_plugin_axios_5659cf26' // Source: ../plugins/axios.ts (mode: 'all')
import nuxt_plugin_api_228341c7 from 'nuxt_plugin_api_228341c7' // Source: ../plugins/api.ts (mode: 'all')
import nuxt_plugin_nuxtServerInit_12036861 from 'nuxt_plugin_nuxtServerInit_12036861' // Source: ../plugins/nuxtServerInit.ts (mode: 'server')
import nuxt_plugin_growthbook_5b027f72 from 'nuxt_plugin_growthbook_5b027f72' // Source: ../plugins/growthbook.ts (mode: 'all')
import nuxt_plugin_varioqub_3e693608 from 'nuxt_plugin_varioqub_3e693608' // Source: ../plugins/varioqub.ts (mode: 'all')
import nuxt_plugin_validation_6d9feac0 from 'nuxt_plugin_validation_6d9feac0' // Source: ../plugins/validation.ts (mode: 'all')
import nuxt_plugin_lazyLoad_4db3c7ff from 'nuxt_plugin_lazyLoad_4db3c7ff' // Source: ../plugins/lazyLoad.ts (mode: 'all')
import nuxt_plugin_mask_e082a766 from 'nuxt_plugin_mask_e082a766' // Source: ../plugins/mask.ts (mode: 'all')
import nuxt_plugin_InfiniteLoading_51ec9ab9 from 'nuxt_plugin_InfiniteLoading_51ec9ab9' // Source: ../plugins/InfiniteLoading.ts (mode: 'all')
import nuxt_plugin_smartComponent_02391605 from 'nuxt_plugin_smartComponent_02391605' // Source: ../plugins/smartComponent.ts (mode: 'all')
import nuxt_plugin_getCanonical_4e6937bb from 'nuxt_plugin_getCanonical_4e6937bb' // Source: ../plugins/getCanonical.ts (mode: 'all')
import nuxt_plugin_resizeWindow_755370b3 from 'nuxt_plugin_resizeWindow_755370b3' // Source: ../plugins/resizeWindow.ts (mode: 'client')
import nuxt_plugin_index_16fee9a7 from 'nuxt_plugin_index_16fee9a7' // Source: ../plugins/mindbox/index.ts (mode: 'client')
import nuxt_plugin_index_0ba7174e from 'nuxt_plugin_index_0ba7174e' // Source: ../plugins/dataLayer/index.ts (mode: 'client')
import nuxt_plugin_index_fa90f08a from 'nuxt_plugin_index_fa90f08a' // Source: ../plugins/refiner/index.ts (mode: 'client')
import nuxt_plugin_dragscroll_506c66d6 from 'nuxt_plugin_dragscroll_506c66d6' // Source: ../plugins/dragscroll.ts (mode: 'client')
import nuxt_plugin_shortkey_225102b4 from 'nuxt_plugin_shortkey_225102b4' // Source: ../plugins/shortkey.ts (mode: 'client')
import nuxt_plugin_initclient_bdf7e1d0 from 'nuxt_plugin_initclient_bdf7e1d0' // Source: ../plugins/init.client.ts (mode: 'client')
import nuxt_plugin_googleoptimize_52a44eab from 'nuxt_plugin_googleoptimize_52a44eab' // Source: ./google-optimize.js (mode: 'all')
import nuxt_plugin_meta_b5aab5ac from 'nuxt_plugin_meta_b5aab5ac' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru"},"title":"05.ru – интернет-магазин","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0"},{"name":"apple-itunes-app","content":"app-id=1539023015, app-argument=https:\u002F\u002F05.ru\u002F"},{"hid":"description","name":"description","content":"Интернет - Магазин 05.ru предлагает вашему вниманию широчайший выбор электроники и бытовой техники. Мы гарантируем качество по самым низким ценам в Дагестане. Доставка бесплатная"},{"name":"yandex-verification","content":"4789624d36292f1c"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fvue\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Fvue\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Fvue\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fvue\u002Fmanifest\u002Fmanifest.webmanifest"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Fvue\u002Ffont\u002FUbuntu-Italic.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Fvue\u002Ffont\u002FUbuntu-Medium.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Fvue\u002Ffont\u002FUbuntu-Regular.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Fvue\u002Ffont\u002Fubuntu-ruble-italic.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Fvue\u002Ffont\u002Fubuntu-ruble-medium.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Fvue\u002Ffont\u002Fubuntu-ruble-regular.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Fvue\u002Ffont\u002FUbuntu-Mono-Regular.woff2","crossorigin":"anonymous"}],"script":[{"hid":"metrika","innerHTML":"(function(m,e,t,r,i,k,a){\n    m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n    m[i].l=1*new Date();\n    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n    (window, document, \"script\", \"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js\", \"ym\");\n    ym(\"85054561\", \"init\", {\"defer\":true,\"clickmap\":true,\"trackLinks\":true,\"accurateTrackBounce\":true,\"webvisor\":true,\"ecommerce\":true});"},{"src":"https:\u002F\u002Fcode.jivosite.com\u002Fwidget\u002F9pBWoPRjwQ","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"__dangerouslyDisableSanitizersByTagID":{"metrika":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"__dangerouslyDisableSanitizers":["noscript"],"noscript":[{"innerHTML":"\u003Cdiv\u003E\u003Cimg src=\"https:\u002F\u002Fmc.yandex.ru\u002Fwatch\u002F85054561\" style=\"position:absolute; left:-9999px;\" alt=\"\" \u002F\u003E\u003C\u002Fdiv\u003E"},{"hid":"gtm-noscript","pbody":true,"innerHTML":""}]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0c8eb7d0 === 'function') {
    await nuxt_plugin_plugin_0c8eb7d0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_runtimeplugin633efce6_fbf82d8c === 'function') {
    await nuxt_plugin_runtimeplugin633efce6_fbf82d8c(app.context, inject)
  }

  if (typeof nuxt_plugin_nodecacheplugin_9945246e === 'function') {
    await nuxt_plugin_nodecacheplugin_9945246e(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_77b2e812 === 'function') {
    await nuxt_plugin_apollomodule_77b2e812(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_runtimeplugin04d6f43d_b4b92bc6 === 'function') {
    await nuxt_plugin_runtimeplugin04d6f43d_b4b92bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin5cd6bd3c_02162cdc === 'function') {
    await nuxt_plugin_distplugin5cd6bd3c_02162cdc(app.context, inject)
  }

  if (typeof nuxt_plugin_persistedState_3bffb41b === 'function') {
    await nuxt_plugin_persistedState_3bffb41b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sharedMutation_432bf589 === 'function') {
    await nuxt_plugin_sharedMutation_432bf589(app.context, inject)
  }

  if (typeof nuxt_plugin_index_dda843de === 'function') {
    await nuxt_plugin_index_dda843de(app.context, inject)
  }

  if (typeof nuxt_plugin_index_7decf890 === 'function') {
    await nuxt_plugin_index_7decf890(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659cf26 === 'function') {
    await nuxt_plugin_axios_5659cf26(app.context, inject)
  }

  if (typeof nuxt_plugin_api_228341c7 === 'function') {
    await nuxt_plugin_api_228341c7(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtServerInit_12036861 === 'function') {
    await nuxt_plugin_nuxtServerInit_12036861(app.context, inject)
  }

  if (typeof nuxt_plugin_growthbook_5b027f72 === 'function') {
    await nuxt_plugin_growthbook_5b027f72(app.context, inject)
  }

  if (typeof nuxt_plugin_varioqub_3e693608 === 'function') {
    await nuxt_plugin_varioqub_3e693608(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_6d9feac0 === 'function') {
    await nuxt_plugin_validation_6d9feac0(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyLoad_4db3c7ff === 'function') {
    await nuxt_plugin_lazyLoad_4db3c7ff(app.context, inject)
  }

  if (typeof nuxt_plugin_mask_e082a766 === 'function') {
    await nuxt_plugin_mask_e082a766(app.context, inject)
  }

  if (typeof nuxt_plugin_InfiniteLoading_51ec9ab9 === 'function') {
    await nuxt_plugin_InfiniteLoading_51ec9ab9(app.context, inject)
  }

  if (typeof nuxt_plugin_smartComponent_02391605 === 'function') {
    await nuxt_plugin_smartComponent_02391605(app.context, inject)
  }

  if (typeof nuxt_plugin_getCanonical_4e6937bb === 'function') {
    await nuxt_plugin_getCanonical_4e6937bb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_resizeWindow_755370b3 === 'function') {
    await nuxt_plugin_resizeWindow_755370b3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_16fee9a7 === 'function') {
    await nuxt_plugin_index_16fee9a7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_0ba7174e === 'function') {
    await nuxt_plugin_index_0ba7174e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_fa90f08a === 'function') {
    await nuxt_plugin_index_fa90f08a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dragscroll_506c66d6 === 'function') {
    await nuxt_plugin_dragscroll_506c66d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_shortkey_225102b4 === 'function') {
    await nuxt_plugin_shortkey_225102b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initclient_bdf7e1d0 === 'function') {
    await nuxt_plugin_initclient_bdf7e1d0(app.context, inject)
  }

  if (typeof nuxt_plugin_googleoptimize_52a44eab === 'function') {
    await nuxt_plugin_googleoptimize_52a44eab(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_b5aab5ac === 'function') {
    await nuxt_plugin_meta_b5aab5ac(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
